// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesktopHeader_wrapper__Eb1Jj","inner":"DesktopHeader_inner__yt8cf","actions":"DesktopHeader_actions__7L_Sx"};